import axios from 'axios';

// Normalize base URL so it always ends with /api
const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
let API_BASE_URL = RAW_API_URL.replace(/\/+$/,'');
if (!/\/api$/.test(API_BASE_URL)) {
  API_BASE_URL += '/api';
}
console.log('[api] Using base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptors for request/response handling
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Auth
export const login = (credentials) => {
  console.log('API login called with credentials for:', credentials.username);
  console.log('Using URL:', `${API_BASE_URL}/login/authenticate`);
  return api.post('/login/authenticate', credentials);
};

// Chantiers
export const listChantiers = () => api.get('/chantiers');
export const getChantier = (id) => api.get(`/chantiers/${id}`);
export const createChantier = (data) => api.post('/chantiers', data);
export const updateChantier = (id, data) => api.put(`/chantiers/${id}`, data);
export const deleteChantier = (id) => api.delete(`/chantiers/${id}`);

// Salariés
export const listSalaries = () => api.get('/salaries');
export const createSalarie = (data) => api.post('/salaries', data);
export const updateSalarie = (id, data) => api.put(`/salaries/${id}`, data);
export const deleteSalarie = (id) => api.delete(`/salaries/${id}`);

// Fournisseurs
export const listFournisseurs = (params) => api.get('/fournisseurs', { params });
export const getFournisseur = (id) => api.get(`/fournisseurs/${id}`);
export const getFournisseurYears = () => api.get('/fournisseurs/years');
export const createFournisseur = (data) => api.post('/fournisseurs', data);
export const updateFournisseur = (id, data) => api.put(`/fournisseurs/${id}`, data);
export const deleteFournisseur = (id) => api.delete(`/fournisseurs/${id}`);

// Charges
export const listCharges = () => api.get('/charges');
export const createCharge = (data) => api.post('/charges', data);
export const createServicesCharge = (chantierId, servicesData, description = '') => {
  // Calculate the total as the sum of all service values
  const servicesTotal = Object.values(servicesData).reduce((sum, val) => sum + Number(val || 0), 0);
  
  return api.post('/charges', {
    chantierId,
    type: 'Services extérieurs',
    name: 'Services extérieurs',
    budget: servicesTotal,
    montant: servicesTotal,
    description,
    details: servicesData
  });
};
export const updateCharge = (id, data) => api.put(`/charges/${id}`, data);
export const deleteCharge = (id) => api.delete(`/charges/${id}`);

// Prestations
export const listPrestations = () => api.get('/prestations');
export const createPrestation = (data) => api.post('/prestations', data);
export const updatePrestation = (id, data) => api.put(`/prestations/${id}`, data);
export const deletePrestation = (id) => api.delete(`/prestations/${id}`);

// Frais Transport Config (backend route: /api/frais-transport-config)
export const getFraisTransportConfig = () => api.get('/frais-transport-config');
// export const updateFraisTransportConfig = (data) => api.put('/frais-transport-config', data);

// Prix Ouvrage (backend route: /api/prix-ouvrage)
export const listPrixOuvrage = () => api.get('/prix-ouvrage');
export const createPrixOuvrage = (data) => api.post('/prix-ouvrage', data);
export const updatePrixOuvrage = (id, data) => api.put(`/prix-ouvrage/${id}`, data);
export const deletePrixOuvrage = async (id) => {
  const response = await fetch(`${API_BASE_URL}/prix-ouvrage/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Erreur lors de la suppression');
  return response.json();
};

// Honoraires
export const listHonoraires = () => api.get('/honoraires');
export const createHonoraire = (data) => api.post('/honoraires', data);
export const updateHonoraire = (id, data) => api.put(`/honoraires/${id}`, data);
export const deleteHonoraire = (id) => api.delete(`/honoraires/${id}`);

// Frais Transport Config API
export const listFraisTransportConfig = async () => {
  const response = await fetch(`${API_BASE_URL}/frais-transport-config`);
  if (!response.ok) throw new Error('Erreur lors de la récupération');
  return response.json();
};

export const createFraisTransportConfig = async (data) => {
  const response = await fetch(`${API_BASE_URL}/frais-transport-config`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Erreur lors de la création');
  return response.json();
};

export const updateFraisTransportConfig = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/frais-transport-config/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Erreur lors de la mise à jour');
  return response.json();
};

export const deleteFraisTransportConfig = async (id) => {
  const response = await fetch(`${API_BASE_URL}/frais-transport-config/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Erreur lors de la suppression');
  return response.json();
};

export default api;
